import { Method as apiMethod } from 'axios'

export const invitationEndpoints = {
  create: {
    method: 'post' as apiMethod,
    url: '/users/invite/check'
  }
}
